import { useEffect, useState } from "react";
import { UserPlus, Trash2, Shield, User as UserIcon } from "lucide-react";
import { Button } from "../components/ui/button";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import InviteModal from "../components/InviteModal";
import { toast } from "sonner";

export default function Team() {
  const { activeWorkspace } = useAuth();
  const [members, setMembers] = useState([]);
  const [inviteOpen, setInviteOpen] = useState(false);
  const isAdmin = activeWorkspace?.role === "admin";

  const load = () => {
    if (activeWorkspace) api.get(`/workspaces/${activeWorkspace.id}/members`).then(({ data }) => setMembers(data));
  };
  useEffect(load, [activeWorkspace]);

  const removeMember = async (id) => {
    try {
      await api.delete(`/workspaces/${activeWorkspace.id}/members/${id}`);
      toast.success("Member removed");
      load();
    } catch (err) {
      toast.error("Failed to remove member");
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-heading text-2xl font-bold tracking-tight sm:text-3xl">Team</h1>
          <p className="mt-1 text-sm text-muted-foreground">{activeWorkspace?.name}</p>
        </div>
        {isAdmin && (
          <Button onClick={() => setInviteOpen(true)} data-testid="invite-team-button">
            <UserPlus className="h-4 w-4" /> Invite Teammate
          </Button>
        )}
      </div>

      <div className="mt-6 overflow-hidden rounded-xl border border-border" data-testid="team-members-list">
        {members.map((m) => (
          <div key={m.id} className="flex items-center justify-between border-b border-border/60 px-5 py-3 last:border-0">
            <div className="flex items-center gap-3">
              {m.role === "admin" ? <Shield className="h-4 w-4 text-primary" /> : <UserIcon className="h-4 w-4 text-muted-foreground" />}
              <div>
                <div className="text-sm font-medium">{m.name || m.email}</div>
                <div className="text-xs text-muted-foreground">
                  {m.email} · {m.status === "pending" ? "Invite pending" : m.role}
                </div>
              </div>
            </div>
            {isAdmin && (
              <button
                onClick={() => removeMember(m.id)}
                data-testid={`remove-member-btn-${m.id}`}
                className="text-muted-foreground hover:text-destructive transition-colors duration-150"
              >
                <Trash2 className="h-4 w-4" />
              </button>
            )}
          </div>
        ))}
      </div>

      <InviteModal open={inviteOpen} onClose={() => setInviteOpen(false)} workspaceId={activeWorkspace?.id} onInvited={load} />
    </div>
  );
}
